import Vue from 'vue'
import { default as VueCompositionApi, onBeforeUnmount, reactive } from '@vue/composition-api'
Vue.use(VueCompositionApi)

export const state = reactive({
  value: ``
})

export default () => {
  return {
    set: ({ value }={}) => {
      state.value = value
      onBeforeUnmount(() => {
        state.value = ``
      })
    }
  }
}
